import React, { useState, useRef, useEffect, useMemo } from "react";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import {
  faCloudUpload,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import infoImg from "../../Utils/assets/img/icons/info_icon.png";
import {
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { Controller, useForm, useFieldArray, useWatch } from "react-hook-form";
import { date, optional, z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "sonner";
import AddressModal from "../Quotation/AddressModal";
import {
  getModuleSeries,
  formatToINR,
  customStyles,
} from "../../Utils/helpers/commonhelper";
import {
  DateField,
  MultipleOpt,
  PhoneNumberInput,
  SelectOpt,
  Text,
  Time,
} from "../../pages/FieldComp";
import { AuthorizationCard } from "../../pages/AuthorizationCard"
import { UpgradePlan } from "../../pages/UpgradePlan"
import { IconXboxX } from "@tabler/icons-react";


// Helpers to normalize incoming values (object | string | number) to string IDs
const idString = (msg) =>
  z.preprocess((val) => {
    if (val == null) return "";
    if (typeof val === "object") {
      if ("value" in val) return String(val.value ?? "");
      return "";
    }
    return String(val);
  }, z.string().min(1, msg));

//optional field
const OptionalIdString = (msg) =>
  z.preprocess((val) => {
    if (val == null) return "";
    if (typeof val === "object") {
      if ("value" in val) return String(val.value ?? "");
      return "";
    }
    return String(val);
  }, z.string());

const asDateString = (msg) =>
  z.preprocess((val) => {
    if (val instanceof Date) return val.toISOString().split("T")[0]; // YYYY-MM-DD format
    return val;
  }, z.string().min(1, msg));
const CreateSalesOrderSchema = z.object({
  contact: idString("Contact name is required"),

  // salesOrderNumber: z.string().min(1, "Quotation number is required"),
  // reference: z.string().min(1, "Reference is required"),
  salesOrderDate: asDateString("Invoice order date is required"),
  shipmentDate: asDateString("Invoice due date is required"),
  // leadOwner: idString("select lead owner"),

  leadOwnerId: idString("Lead owner is required"),
  deal: OptionalIdString(),
  accountsReceivables: OptionalIdString(),
  paymentTerm: idString(),
  shortDescription: z.string().min(1, "Short description is required"),
  items: z
    .array(
      z.object({
        item: z.preprocess(
          (val) => {
            if (val == null) return null;
            if (typeof val === "string" || typeof val === "number") {
              const s = String(val);
              return { value: s, label: s };
            }
            return val;
          },
          z
            .object({
              value: z.string(),
              label: z.string(),
            })
            .nullable()
            .refine((val) => val !== null, { message: "Item is required" })
        ),
        quantity: z.coerce.number().min(1, "Quantity must be at least 1"),
        rate: z.coerce.number().min(0, "Rate must be a positive number"),
        gst: z.coerce
          .number()
          .min(0, "GST must be a positive number")
          .optional(),
        discount: z.coerce
          .number()
          .min(0, "Discount must be a positive number")
          .optional(),
        discountType: z.string().optional(),
        description: z.string().optional(),
      })
    )
    .min(1, "At least one item is required"),
  termsConditions: z.string().optional(),
  attachment: z.any().optional(),
  customerNote: z.string().optional(),
  specialDiscount: z.coerce
    .number()
    .min(0, "Discount must be a positive number")
    .optional(),
  shippingCharge: z.coerce
    .number()
    .min(0, "Shipping charge must be a positive number")
    .optional(),
  specialDiscountType: z.string().optional(),
  gstPercentage: z.coerce
    .number()
    .min(0, "GST must be a positive number")
    .optional(),
});
export const CreateInvoiceOrder = ({ onClose }) => {
  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });
  const customer_id = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization || "";
  const rf = customer?.token?.authentication || "";
  const extras = { customer, setCustomer, rf, navigate };
  const headers = {
    Authorization: token,
    Authentication: rf,
  };
  const [draftClick, setDraftClicked] = useState(false);
  const [orderedItems, setOrderedItems] = useState({});

  const [leadOwner, setLeadOwner] = useState([]);
  const [contactOption, setContactOption] = useState([]);
  const [dealOption, setDealOptions] = useState([]);
  const [productOption, setProductOption] = useState([]);
  const [dealId, setDealId] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [productToCompaire, setProductToCompair] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  // select quotation
  const [quotation, setQuotation] = useState([]);
  const [quotationId, setQuotationId] = useState(null);

  const [tableData, setTableData] = useState([]);

  const [isEditing, setIsEditing] = useState(true);
  const [text, setText] = useState("");
  const textareaRef = useRef(null);
  const [show, setShow] = useState(false);
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [showTextareaIndex, setShowTextareaIndex] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedLeadOwner, setSelectedLeadOwner] = useState(null);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [selectedQuotation, setSelectedQuotation] = useState(null);

  const [quotationModule, setQuotationModule] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const [isDragging, setIsDragging] = useState(false);

  const newOptions = ["%", "₹"];
  const [selected, setSelected] = useState(newOptions[0]);
  const [open, setOpen] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [showBillingModal, setShowBillingModal] = useState(false);
  const [showShippingModal, setShowShippingModal] = useState(false);

  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const tomorrow = tomorrowDate.toISOString().split("T")[0];

  const permission = customer.customer_details?.permission
  // permissions to handle
  const isInvoice = Boolean(permission?.find(c => c.module_name === "invoice"))
  const invoicePermission = isInvoice && permission?.filter(c => c.module_name === "invoice")
  const user_type = Number(customer.customer_details?.user_type)
  const invoiceGrant = {
    isView: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name === "invoice")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name === "invoice")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name === "invoice")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isInvoice && invoicePermission?.find(c => c.feature_name === "invoice")?.delete)) : true,
  }

  const generateDynamicSchema = (fields) => {
    const schemaFields = {};

    fields.forEach((field) => {
      const fieldId = field.id;

      switch (field.label_type) {
        case "text":
        case "largeText":
        case "address":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.string().min(1, `${field.label_name} is required`)
              : z.string().optional();
          break;

        case "numerical":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.string({ required_error: `${field.label_name} is required` })
              : z.string().optional();
          break;

        case "monetary":
          schemaFields[fieldId] = field.is_required === "yes"
            ? z.preprocess(
              (val) => (val === "" || val === null || val === undefined ? undefined : Number(val)),
              z.number({
                required_error: `${field.label_name} is required`,
                invalid_type_error: "Please enter a valid number"
              })
                .min(0.01, "Amount must be positive")
            )
            : z.preprocess(
              (val) => (val === "" || val === null || val === undefined ? null : Number(val)),
              z.number().min(0, "Amount cannot be negative").optional().nullable()
            );
          break;

        case "single-option":
        case "user":
        case "person":
        case "organization":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.string().min(1, `${field.label_name} is required`)
              : z.string().optional().nullable().or(z.literal(""));
          break;

        case "date":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.string().min(1, `${field.label_name} is required`)
              : z.string().optional();
          break;

        case "date range":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z
                .object({
                  start: z.string().min(1, "Start date is required"),
                  end: z.string().min(1, "End date is required"),
                })
                .refine((data) => data.start <= data.end, {
                  message: "End date must be after start date",
                })
              : z
                .object({
                  start: z.string(),
                  end: z.string(),
                })
                .optional();
          break;

        case "time":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.string().min(1, `${field.label_name} is required`)
              : z.string().optional();
          break;

        case "time-range":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.object({
                start: z.string().min(1, "Start time is required"),
                end: z.string().min(1, "End time is required"),
              })
              : z
                .object({
                  start: z.string(),
                  end: z.string(),
                })
                .optional();
          break;

        case "phone":
          schemaFields[fieldId] =
            field.is_required === "yes"
              ? z.string(z.string().min(1, "phone is requ"))
              : z.string().optional();
          break;
        case "multiple-option": // Added multiple-option schema
          schemaFields[fieldId] = // Changed from fieldName
            field.is_required === "yes"
              ? z.array(z.string()).min(1, `${field.label_name} is required`)
              : z.array(z.string()).optional();
          break;

        // case 'phone_multiple':
        //     schemaFields[fieldName] = field.is_required === "yes"
        //         ? z.array(z.object({
        //             phone: z.string().min(1, "Phone number is required"),
        //             phone_type: z.string(),
        //             country_code: z.string(),
        //             countryName: z.string()
        //         })).min(1, "At least one phone number is required")
        //         : z.array(z.object({
        //             phone: z.string(),
        //             phone_type: z.string(),
        //             country_code: z.string(),
        //             countryName: z.string()
        //         })).optional();
        //     break;

        default:
          schemaFields[fieldId] = z.any().optional();
      }
    });

    return z.object(schemaFields);
  };
  const [dynamicFields, setDynamicFields] = useState([]);
  // groped state to hold the dynamic group data
  const [grouped, setGrouped] = useState([]);
  // ungroped state to hold the dynamic group data
  const [ungrouped, setUnGrouped] = useState([]);
  const [allContacts, setAllContacts] = useState([]);
  // Memoize the combined schema to avoid unnecessary recalculations
  const finalSchema = useMemo(() => {
    if (dynamicFields.length === 0) {
      return CreateSalesOrderSchema;
    }

    // Combine grouped and ungrouped fields
    const allDynamicFields = [
      ...(grouped?.flatMap((g) => g.groupFields || []) || []),
      ...(ungrouped || []),
    ];

    if (allDynamicFields.length === 0) {
      return CreateSalesOrderSchema;
    }

    const dynamicSchema = generateDynamicSchema(allDynamicFields);

    // Merge static and dynamic schemas
    return CreateSalesOrderSchema.merge(dynamicSchema);
  }, [grouped, ungrouped, dynamicFields]);

  const {
    handleSubmit,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    formState: { errors, isValid },
    watch,
    trigger,
    reset,
    register,
  } = useForm({
    resolver: zodResolver(finalSchema),
    mode: "onChange",
    defaultValues: {
      salesOrderDate: today,
      shipmentDate: tomorrow,
      items: [
        {
          item: null,
          quantity: 1,
          rate: 0,
          gst: 0,
          discount: 0,
          discountType: "Percentage",
          description: "",
        },
      ],
      specialDiscountType: "%",
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const itemOptionsPyments = [
    { value: "15 Days", label: "15 Days" },
    { value: "25 Days", label: "25 Days" },
    { value: "30 Days", label: "30 Days" },
    { value: "60 Days", label: "60 Days" },
  ];

  const leadOwnerOptions = useMemo(
    () =>
      leadOwner.map((lead) => ({
        value: lead.leadId,
        label: lead.leadName,
      })),
    [leadOwner]
  );

  // Fetch All lead owner
  // Fetch Owners
  const fetchOwners = async () => {
    const res = await GetRequest(
      `users/users/fetchUserAsOwner/${customer.customer_details.customer_id}`,
      { headers },
      { customer, setCustomer, rf: headers.Authentication, navigate }
    );

    if (res.err) {
      toast.error("Error Fetching Data");
      return;
    }

    const owners = res.data.map((lead) => ({
      leadName: lead.full_name,
      leadId: lead.id,
    }));

    setLeadOwner(owners);

    const currentOwner = getValues("leadOwnerId");
    if (!currentOwner && owners.length > 0) {
      setValue("leadOwnerId", owners[0].leadId, { shouldValidate: true });
      setSelectedLeadOwner({
        value: owners[0].leadId,
        label: owners[0].leadName,
      });
    }
  };

  useEffect(() => {
    fetchOwners();
  }, []);

  const items = useWatch({
    control,
    name: "items",
  });

  // use effct for quantity input field error!!

  // useEffect(() => {
  //   if (!items) return;

  //   items.forEach((row, index) => {
  //     const productId = row?.item?.value;
  //     const qty = Number(row?.quantity);
  //     const orderedQty = Number(orderedItems[productId]);

  //     if (!productId || orderedQty == null) {
  //       clearErrors(`items.${index}.quantity`);
  //       return;
  //     }

  //     if (qty > orderedQty) {
  //       setError(`items.${index}.quantity`, {
  //         type: "manual",
  //         message: `Max allowed quantity is ${orderedQty}`,
  //       });
  //     } else {
  //       clearErrors(`items.${index}.quantity`);
  //     }
  //   });
  // }, [items, orderedItems]);

  useEffect(() => {
    async function fetchQuotation() {
      const data = await getModuleSeries(customer_id, "invoice");
      setQuotationModule(`${data.prefix}` + "-" + `${data.incremental_number}`);
      // setValue(
      //   "salesOrderNumber",
      //   `${data.prefix}` + "-" + `${data.incremental_number}`
      // );
    }
    fetchQuotation();
  }, []);

  // Memoize options to prevent unnecessary re-renders
  const contactOptions = useMemo(
    () =>
      contactOption.map((conta) => ({
        value: conta.contactId,
        label: conta.contactName,
        company_name: conta.company_name,
        company_id: conta.company_id,
        billingAddresses: conta.billingAddresses || [],
        shippingAddresses: conta.shippingAddresses || [],
      })),
    [contactOption]
  );

  // Custom option component for better formatting (optional)
  const CustomOption1 = ({
    innerRef,
    innerProps,
    data,
    isSelected,
    isFocused,
  }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: "8px 12px",
        backgroundColor: isSelected
          ? "#007bff"
          : isFocused
            ? "#f8f9fa"
            : "white",
        color: isSelected ? "white" : "#333",
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: "500" }}>{data.label}</div>
      <div
        style={{ fontSize: "12px", color: isSelected ? "#e9ecef" : "#6c757d" }}
      >
        {data.company_name || "No Company"}
      </div>
    </div>
  );

  const dealOptions = useMemo(
    () =>
      dealOption.map((deal) => ({
        value: deal.dealId,
        label: deal.dealName,
      })),
    [dealOption]
  );

  const productOptions = useMemo(
    () =>
      productOption.map((product) => ({
        value: product.id,
        label: product.service,
        price: product.price,
        tax: product.tax,
      })),
    [productOption]
  );

  const handleChange = (e) => {
    setFile(e.target.files[0]);
    setValue("attachment", e.target.files[0]);
  };

  const handleClickButton = () => {
    fileInputRef.current.click();
  };

  const handleSelectChange = (name, selectedOption, fieldOnChange) => {
    fieldOnChange(selectedOption?.value || "");

    // Update local state for selected values
    if (name === "contact") {
      setSelectedContact(selectedOption);
      setCompanyId(selectedOption.company_id);
      setContactId(selectedOption.value);
      setSelectedDeal(null);
      setDealId(null);
      setValue("deal", "");
      setDealOptions([]);

      setValue("items", [
        {
          item: null,
          quantity: 1,
          rate: 0,
          gst: 0,
          discount: 0,
          discountType: "Percentage",
          description: "",
        },
      ]);
    } else if (name === "leadOwnerId") {
      setSelectedLeadOwner(selectedOption);
    } else if (name === "deal") {
      setSelectedDeal(selectedOption);
      if (selectedOption?.value) {
        setDealId(selectedOption.value);
      }
    } else if (name === "quotation") {
      setSelectedQuotation(selectedOption);
      if (selectedOption?.value) {
        setQuotationId(selectedOption.value);
      }
    }
  };

  // draft option
  const handleDraftClick = () => {
    setDraftClicked(true);
  };

  const handleCancel = () => {
    setDraftClicked(false);
    setTimeout(() => {
      if (onClose) onClose();
      navigate("/salesOrder?type=invoice");
    }, 100);
  };

  const handleFile = (selectedFile) => {
    if (!selectedFile) return;
    setFile(selectedFile);
    setValue("attachment", selectedFile);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const droppedFile = e.dataTransfer.files[0];
    handleFile(droppedFile);
  };
  const handleBillingSubmit = async (data) => {
    const payload = {
      company_id: companyId,
      billing_address: [
        ...(selectedContact.billingAddresses || []).map((addr) => ({
          address: addr.address,
          country: addr.country,
          state: addr.state,
          city: addr.city,
          zipcode: addr.zipcode,
          selected: "", // sab purane ko empty kar do
          for: addr.for === "shipping" ? "shipping" : "", // agar shipping tha to rehne do
        })),
        {
          address: data.address,
          country: data.country || "",
          state: data.state || "",
          city: data.city || "",
          zipcode: data.zipcode,
          selected: "selected", // naya hamesha selected hoga
          for: "", // billing ke liye hamesha blank
        },
      ],
    };

    const res = await PutRequest(
      `/quotation/createBillingAddress/`,
      payload,
      { headers },
      extras
    );

    if (res.status === "success") {
      // toast.success(res.message);

      let updatedList = [];
      try {
        updatedList = JSON.parse(res.data.billing_address);
      } catch (err) {
        console.error("Error parsing address list:", err);
      }

      setSelectedContact((prev) => ({
        ...prev,
        billingAddresses: updatedList,
        shippingAddresses: updatedList,
      }));

      setShowBillingModal(false);
    }
  };

  const handleShippingSubmit = async (data) => {
    const payload = {
      company_id: companyId,
      billing_address: [
        ...(selectedContact.billingAddresses || []).map((addr) => ({
          address: addr.address,
          country: addr.country,
          state: addr.state,
          city: addr.city,
          zipcode: addr.zipcode,
          selected: addr.selected || "",
          for: addr.for === "shipping" ? "" : addr.for || "",
        })),
        {
          address: data.address,
          country: data.country || "",
          state: data.state || "",
          city: data.city || "",
          zipcode: data.zipcode,
          selected: data.selected || "",
          for: "shipping",
        },
      ],
    };

    const res = await PutRequest(
      `/quotation/createBillingAddress/`,
      payload,
      { headers },
      extras
    );

    if (res.status === "success") {
      toast.success(res.message);

      let updatedList = [];
      try {
        updatedList = JSON.parse(res.data.billing_address);
      } catch (err) {
        console.error("Error parsing address list:", err);
      }

      setSelectedContact((prev) => ({
        ...prev,
        billingAddresses: updatedList,
        shippingAddresses: updatedList,
      }));

      setShowShippingModal(false);
    }
  };

  const handleChangeTextArea = (index) => {
    setShowTextareaIndex(showTextareaIndex === index ? null : index);
  };

  const handleBlur = (index) => {
    const description = getValues(`items.${index}.description`);
    if (description && description.trim() !== "") {
      setIsEditing(false);
    }
  };

  // phonje number validator
  const validatePhoneNumber = (rawNumber, countryCode) => { };

  const handlePClick = (index) => {
    setIsEditing(true);
    setShowTextareaIndex(index);
  };

  const options = [
    { value: "INR", label: "₹", icon: "ti ti-currency-rupee" },
    { value: "Percentage", label: "%", icon: "bi bi-percent" },
  ];

  const discountTypeOptions = [
    { value: "%", label: "%" },
    { value: "₹", label: "₹" },
  ];
  const dropdownRefs = useRef([]);

  // // Fetch Owners
  // const fetchOwners = async () => {};

  // useEffect(() => {
  //   fetchOwners();
  // }, []);

  const fetchAllContacts = async () => {
    try {
      const res = await GetRequest(
        `quotation/fetchContacts/${customer?.customer_details?.id}/${customer.customer_details.customer_id}/${customer?.customer_details?.user_type}`,
        { headers },
        extras
      );

      if (res.status !== "success") {
        return toast.error(res.message || "Failed to find contacts");
      }
      if (Array.isArray(res.data)) {
        const data = res.data.map((contact) => {
          let billingAddresses = [];

          if (contact.billing_address) {
            try {
              billingAddresses = JSON.parse(contact.billing_address);
            } catch (e) {
              console.error("Billing address parse error:", e);
            }
          }
          if (billingAddresses.length === 0) {
            billingAddresses.push({
              address: contact.address,
              city: contact.city_name,
              state: contact.state_name,
              country: contact.country_name,
              zipcode: contact.zipcode,
              selected: "selected",
              for: "billing",
            });
          }

          const shippingAddresses = [...billingAddresses];
          return {
            contactName: contact.contact_full_name,
            contactId: contact.id,
            company_id: contact.company_id,
            company_name: contact.company_name,
            billingAddresses,
            shippingAddresses,
          };
        });
        setContactOption(data);
        // setDealOptions([]);
        setSelectedDeal([]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      toast.error("Something went wrong while fetching contacts");
    }
  };

  useEffect(() => {
    fetchAllContacts();
  }, [customer_id]);

  const fetchAllSalesOrder = async () => {
    try {
      const res = await GetRequest(
        `/invoice/fetchContactSales_order/${contactId}`,
        { headers },
        extras
      );

      if (res.status === "success") {
        const data = res.data.map((deal) => ({
          dealName: deal.sale_no,
          dealId: deal.id,
        }));
        setDealOptions(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAllSalesOrder();
  }, [contactId, selectedContact]);

  const fetchProductByDealId = async () => {
    try {
      const res = await GetRequest(
        `invoice/fetchItemsOfSales_order/${dealId}`,
        { headers },
        extras
      );

      if (res.status !== "success") {
        return toast.error(res.message || "Failed to fetch products");
      }
      const itemsFromAPI = res?.data?.items || [];

      if (itemsFromAPI.length > 0) {
        const initialItems = itemsFromAPI.map((product) => ({
          item: {
            value: product.product_id,
            label: product.name || product.service,
          },
          quantity: product.quantity || 1,
          rate: product.Rate || 0,
          gst: product.gst || 0,
          discount: product.discount,
          discountType: product.discountType,
          description: "",
        }));

        setValue("shippingCharge", res?.data?.shipping_Charge);
        setValue(
          "specialDiscountType",
          res?.data?.special_DiscountType || "Percentage"
        );
        setValue("specialDiscount", res?.data?.special_discount);
        setValue("items", initialItems);
      }
      const orderedMap = {};

      itemsFromAPI.forEach((product) => {
        orderedMap[product.product_id] = product.quantity; // ordered qty
      });
      setOrderedItems(orderedMap);
    } catch (error) {
      console.error("Error fetching product by dealId:", error);
    }
  };

  // use effect to fetch deals or quotations related products
  useEffect(() => {
    if (quotationId) {
    } else if (dealId) {
      fetchProductByDealId();
    } else {
      setProductToCompair([]); // No quotation or deal
    }
  }, [quotationId, dealId]);

  const handleDeleteRow = (index) => {
    remove(index);
  };

  const handleSelect = (index, value) => {
    setValue(`items.${index}.discountType`, value);
  };

  const handleProductSelect = (selected, index, fieldOnChange) => {
    fieldOnChange(selected);

    if (selected) {
      const product = productOption.find((p) => p.id === selected.value);
      if (product) {
        setValue(`items.${index}.rate`, product.price || 0, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
        setValue(`items.${index}.gst`, product.tax || 0, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });

        setValue(`items.${index}.quantity`, 1, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
      }
    } else {
      setValue(`items.${index}.rate`, 0, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      setValue(`items.${index}.gst`, 0, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });

      setValue(`items.${index}.quantity`, 1, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  };

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     padding: "0.1rem 0.75rem",
  //     minHeight: "50px",
  //     backgroundPosition: "right 0.4rem center",
  //     border: "1px solid #ccc",
  //   }),
  //   placeholder: (provided) => ({
  //     ...provided,
  //     margin: "1.2rem 0px 0rem",
  //     fontSize: "0.9rem",
  //   }),
  //   singleValue: (provided) => ({
  //     ...provided,
  //     margin: "1.2rem 0px 0rem",
  //   }),
  //   indicatorsContainer: (provided) => ({
  //     ...provided,
  //     paddingTop: "0.1rem",
  //     paddingBottom: "0.1rem",
  //   }),
  //   dropdownIndicator: (provided) => ({
  //     ...provided,
  //     padding: "0.25rem",
  //   }),
  // };

  const customStyle = {
    control: (provided) => ({
      ...provided,
      padding: "0rem 0.5rem 0rem",
      minHeight: "35px",
      maxHeight: 38,
      backgroundPosition: "right 0.4rem center",
      border: "1px solid #ccc",
      boxShadow: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: "0rem 0px 0.2rem",
      fontSize: "0.9rem",
    }),
  };

  const calculateGstAmount = () => {
    const gstPercentage = getValues("gstPercentage") || 0;
    const subTotal = parseFloat(calculateSubTotal());
    const discountAmount = parseFloat(calculateDiscountAmount());
    const amountAfterDiscount = subTotal - discountAmount;
    const gstAmount = (amountAfterDiscount * gstPercentage) / 100;

    return gstAmount.toFixed(2);
  };

  const salesOrderDate = watch("salesOrderDate");
  const shipmentDate = watch("shipmentDate");

  const qDate = new Date(salesOrderDate);
  const eDate = new Date(shipmentDate);

  // Fetch All quotations
  const fetchChartOfAccount = async () => {
    try {
      const res = await GetRequest(
        `masters/fetchChartOfAccount/${customer_id}`,
        { headers },
        extras
      );
      if (res.status === "success") {
        const data = res.data.map((quotation) => ({
          quotationName: quotation.account_name,
          quotationCode: quotation.account_code,
          quotationId: quotation.id,
        }));
        setQuotation(data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchChartOfAccount();
  }, [selectedContact]);

  // quotations options
  const quotationOptions = useMemo(
    () =>
      quotation.map((q) => ({
        value: q.quotationId,
        label: q.quotationName,
        account_code: q.quotationCode,
      })),
    [quotation]
  );

  useEffect(() => {
    if (salesOrderDate) {
      trigger("shipmentDate");
    }
  }, [salesOrderDate, trigger, shipmentDate]);

  const onSubmit = async (data) => {
    console.log("hi there")
    setLoading(true);
    try {
      for (let i = 0; i < data.items.length; i++) {
        const row = data.items[i];
        const orderedQty = orderedItems[row?.item?.value];

        if (orderedQty != null && row.quantity > orderedQty) {
          setLoading(false);
          return toast.error(
            `${row.item.label} quantity cannot exceed ordered quantity (${orderedQty})`
          );
        }
      }

      const { grandTotal, roundOff } = calculateGrandTotal();

      // const selectedBilling =
      //   selectedContact?.billingAddresses?.find(
      //     (addr) => addr.selected === "selected"
      //   ) || null;

      // const selectedShipping =
      //   selectedContact?.shippingAddresses?.find(
      //     (addr) => addr.selected === "selected"
      //   ) || null;

      const selectedBilling =
        selectedContact?.billingAddresses?.find(
          (addr) => addr.selected === "selected"
        ) || null;

      const selectedShipping =
        selectedContact?.shippingAddresses?.find(
          (addr) => addr.for === "shipping"
        ) ||
        selectedContact?.shippingAddresses?.find(
          (addr) => addr.selected === "selected"
        ) ||
        selectedContact?.shippingAddresses?.[0];

      const groupedGstMap = calculateGroupedGST();

      const gstBreakdown = Object.entries(groupedGstMap).map(
        ([gst, amount]) => ({
          gst,
          amount,
        })
      );

      let status;
      if (draftClick) {
        status = "draft";
      } else {
        status = "pending";
      }

      const custom_fields = [];
      const staticFieldsPayload = { ...data };
      dynamicFields.forEach((field) => {
        const fieldName = field.id;
        if (fieldName && data.hasOwnProperty(fieldName)) {
          let formattedValue = data[fieldName];
          let isRangeField = false; // Initialize flag for range property

          // Handle complex types for custom_fields payload
          if (
            field.label_type === "date range" ||
            field.label_type === "time-range"
          ) {
            isRangeField = true; // Set flag for range fields
            // Ensure both start and end are present before sending
            if (
              !formattedValue ||
              (!formattedValue.start && !formattedValue.end)
            ) {
              formattedValue = { start: "", end: "" }; // Send empty object if range is incomplete/empty
            }
          } else if (field.label_type === "multiple-option") {
            // Ensure it's an array
            if (!Array.isArray(formattedValue)) {
              formattedValue = []; // Send empty array if not an array
            }
          }
          const customFieldEntry = {
            field_id: field.id.toString(), // Ensure ID is a string
            value: formattedValue,
            range: isRangeField ? true : false,
          };
          custom_fields.push(customFieldEntry);
          // Remove dynamic field from static payload to avoid duplication
          delete staticFieldsPayload[fieldName];
        }
      });

      const dataToSend = {
        customer_id: customer_id,
        contact_id: selectedContact?.contactId || data.contact,
        sales_id: data.deal,
        // reference_number: data.reference,
        invoice_date: data.salesOrderDate,
        due_date: data.shipmentDate,
        owner_id: data.leadOwnerId,
        customer_note: data.customerNote,

        quotation_id: quotationId,
        payment_terms: data.paymentTerm,
        subject: data.shortDescription,
        account_receivables: data.accountsReceivables,
        items: [
          {
            itemDetails: data.items.map((val, i) => {
              const quantity = val.quantity || 0;
              const rate = val.rate || 0;
              const discount = val.discount || 0;
              const discountType = val.discountType || "Percentage";
              const discription = val.description || "";
              // Calculate discounted amount
              let discountedAmount = quantity * rate;
              if (discountType === "Percentage") {
                discountedAmount -= (discountedAmount * discount) / 100;
              } else {
                discountedAmount -= discount;
              }

              return {
                product_id: val.item.value,
                name: val.item.label,
                quantity: quantity,
                itemDescription: discription,
                Rate: rate,
                gst: val.gst,
                discount: discount,
                discountType: discountType,
                amount: quantity * rate, // original amount before discount
                discountedAmount: parseFloat(discountedAmount.toFixed(2)), // discounted price
              };
            }),
            "sub-total": calculateSubTotal(),
            "special-discount": data.specialDiscount,
            gstBreakdown,
            "grand-total": grandTotal,
            special_DiscountType: data.specialDiscountType,
            special_Discount_Amount: calculateDiscountAmount(),
            shipping_Charge: data.shippingCharge,
          },
        ],

        customer_note: data.customerNote,
        // customer_id: customer_id,
        terms_condition: data.termsConditions || "",
        attachment: data.attachment,
        order_status: status,
        user_login_id: customer?.customer_details?.id,

        billing_address: selectedBilling,
        shipping_address: selectedShipping,
      };

      const finalPayload = {
        ...dataToSend,
        custom_fields,
      };

      const res = await PostRequest(
        `/invoice/createInvoice`,
        finalPayload,
        true,
        { headers },
        extras
      );

      if (res.status !== "success") {
        toast.error(res.message || "Failed to generate invoice order");
        setLoading(false);
      } else {
        toast.success(res.message || "Invoice order created successfully!");

        reset();
        setLoading(false);
        setDraftClicked(false);
        setTimeout(() => {
          navigate("/salesOrder?type=invoice");
        }, 300);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!");
    }
  };

  const calculateItemAmount = (index) => {
    const quantity = getValues(`items.${index}.quantity`) || 0;
    const rate = getValues(`items.${index}.rate`) || 0;
    const discount = getValues(`items.${index}.discount`) || 0;
    const discountType =
      getValues(`items.${index}.discountType`) || "Percentage";

    let amount = quantity * rate;

    if (discountType === "Percentage") {
      amount -= (amount * discount) / 100;
    } else {
      amount -= discount;
    }

    return parseFloat(amount.toFixed(2));
  };

  const calculateItemNetAmount = (index) => {
    const baseAmount = calculateItemAmount(index); // without special discount
    const specialDiscountForItem = calculateSpecialDiscountForItem(index);

    let netAmount = baseAmount - specialDiscountForItem;

    // GST apply
    const gst = getValues(`items.${index}.gst`) || 0;
    if (gst > 0) {
      netAmount += (netAmount * gst) / 100;
    }

    return parseFloat(netAmount.toFixed(2));
  };
  const calculateSpecialDiscountForItem = (index) => {
    const subTotal = fields.reduce(
      (sum, _, i) => sum + calculateItemAmount(i),
      0
    );
    const itemAmount = calculateItemAmount(index);

    const specialDiscount = getValues("specialDiscount") || 0;
    const specialDiscountType = getValues("specialDiscountType") || "%";

    let totalSpecialDiscount = 0;
    if (specialDiscountType === "%") {
      totalSpecialDiscount = (subTotal * specialDiscount) / 100;
    } else {
      totalSpecialDiscount = specialDiscount;
    }

    if (subTotal <= 0) return 0;
    return parseFloat(
      ((itemAmount / subTotal) * totalSpecialDiscount).toFixed(2)
    );
  };

  const calculateSubTotal = () => {
    let subTotal = 0;
    fields.forEach((_, index) => {
      subTotal += calculateItemAmount(index);
    });
    return subTotal.toFixed(2);
  };

  const calculateDiscountAmount = () => {
    const specialDiscount = Number(getValues("specialDiscount")) || 0;
    const specialDiscountType = getValues("specialDiscountType") || "%";
    const subTotalBeforeSpecial = fields.reduce((sum, _, index) => {
      const qty = getValues(`items.${index}.quantity`) || 0;
      const rate = getValues(`items.${index}.rate`) || 0;
      const discount = getValues(`items.${index}.discount`) || 0;
      const discountType =
        getValues(`items.${index}.discountType`) || "Percentage";

      let amt = qty * rate;
      if (discountType === "Percentage") {
        amt -= (amt * discount) / 100;
      } else {
        amt -= discount;
      }
      return sum + amt;
    }, 0);

    if (specialDiscountType === "%") {
      return ((subTotalBeforeSpecial * specialDiscount) / 100).toFixed(2);
    } else {
      return specialDiscount.toFixed(2);
    }
  };

  const calculateGroupedGST = () => {
    const gstMap = {};
    fields.forEach((_, index) => {
      const gst = getValues(`items.${index}.gst`) || 0;
      if (gst > 0) {
        const baseAmount = calculateItemAmount(index);
        const discount = calculateSpecialDiscountForItem(index);
        const netAmount = baseAmount - discount;

        const gstAmount = (netAmount * gst) / 100;
        gstMap[gst] = (gstMap[gst] || 0) + gstAmount;
      }
    });
    return gstMap;
  };

  const calculateGrandTotal = () => {
    const subTotal = Number(calculateSubTotal()) || 0;
    const discount = Number(calculateDiscountAmount()) || 0;
    const gstGroups = calculateGroupedGST();

    const gstTotal = Object.values(gstGroups).reduce(
      (acc, val) => acc + Number(val),
      0
    );

    const shippingCharge = Number(getValues("shippingCharge")) || 0;

    const totalBeforeRound = subTotal - discount + gstTotal + shippingCharge;

    const roundedTotal = Math.round(totalBeforeRound);
    const roundOff = roundedTotal - totalBeforeRound;

    return { grandTotal: roundedTotal, roundOff };
  };

  const { roundOff, grandTotal } = calculateGrandTotal();
  const specialDiscount = useWatch({ control, name: "specialDiscount" });
  const specialDiscountType = useWatch({
    control,
    name: "specialDiscountType",
  });
  const shippingCharge = useWatch({ control, name: "shippingCharge" });

  //use effect for dynamic fields
  useEffect(() => {
    (async () => {
      try {
        const res = await GetRequest(
          `/common/fetchCustomFields/${customer_id}/invoice`,
          { headers },
          extras
        );

        if (res.success === false || res.success === "fail") {
          toast.error(res.message);
          return;
        }
        res.data?.grouped != {} &&
          setGrouped(res.data?.grouped && res.data?.grouped);
        res.data?.ungrouped != {} &&
          setUnGrouped(res.data?.ungrouped && res.data?.ungrouped);
        // Update dynamic fields state to trigger schema recalculation
        const allFields = [
          ...(res.data?.grouped?.flatMap((g) => g.groupFields || []) || []),
          ...(res.data?.ungrouped || []),
        ];
        setDynamicFields(allFields);
      } catch (error) {
        toast.error("Internal Server Error");
        return;
      }
    })();
  }, [customer]);

  console.log("watch", watch())
  // Custom option component for better formatting (optional)
  const CustomOption2 = ({
    innerRef,
    innerProps,
    data,
    isSelected,
    isFocused,
  }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: "8px 12px",
        backgroundColor: isSelected
          ? "#007bff"
          : isFocused
            ? "#f8f9fa"
            : "white",
        color: isSelected ? "white" : "#333",
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: "500" }}>{data.label}</div>
      <div
        style={{ fontSize: "12px", color: isSelected ? "#e9ecef" : "#6c757d" }}
      >
        {data.account_code || "no code"}
      </div>
    </div>
  );

  return (
    <>
      {!isInvoice && <UpgradePlan moduleName="Invoice" />}
      {!invoiceGrant?.isCreate ? <AuthorizationCard /> : <>
        <div
          style={{
            borderRadius: 7,
            background: "#fff",
            height: "calc(100vh - 12vh)",
            border: "1px solid lightblue",
            overflow: "clip",
          }}
        >
          <div
            className="header mb-0 position-sticky top-0 p-3 "
            style={{
              borderBottom: "1px solid lightblue",
              zIndex: 11,
              background: "#fff",
            }}
          >
            <div className="d-flex align-center justify-content-between">
              <div className="d-flex">
                <h3
                  className=" mb-0"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "22px",
                  }}
                >
                  {" "}
                  Invoice
                </h3>
                <p
                  className="mt-1 mx-3 text-success fw-semibold"
                  style={{ fontWeight: "14px" }}
                >
                  (#{quotationModule})
                </p>
              </div>
              <button
                className="btn btn-default-outline"
                aria-label="Go Back"
                type="button"
                onClick={handleCancel}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            className="form-container"
            encType="multipart/form-data"
            style={{
              margin: 0,
              overflowY: "auto",
              height: "100%",
              paddingLeft: "0px",
              paddingTop: "12px",
              position: "relative",
            }}
          >
            <Row className="ms-0 w-100 mb-0">
              <Col md={2} style={{ borderRight: "1px solid #d4e7ed" }}>
                <div
                  style={{ position: "sticky", top: "1rem" }}
                  className=" mt-3"
                >
                  <ul className=" ps-3" style={{ listStyle: "none" }}>
                    <li className="position-relative border-start ps-3 py-2 pt-0 ps-4">
                      <span
                        className="position-absolute  start-0 translate-middle bg-primary rounded-circle"
                        style={{
                          width: 10,
                          height: 10,
                          top: 11,
                          border: "1px solid #0099ff",
                        }}
                      ></span>
                      <a
                        href="#companyDetailsSection"
                        style={{ color: "#676262" }}
                      >
                        {" "}
                        Invoice Details{" "}
                      </a>
                    </li>

                    <li className="position-relative border-start ps-3 py-2 ps-4">
                      <span
                        className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                        style={{ width: 10, height: 10 }}
                      ></span>
                      <a href="#itemsDetailsSection" style={{ color: "#676262" }}>
                        {" "}
                        Items Details{" "}
                      </a>
                    </li>
                    <li className="position-relative border-start ps-3 py-2 ps-4">
                      <span
                        className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                        style={{ width: 10, height: 10 }}
                      ></span>
                      <a
                        href="#termsAndConditionsSec"
                        style={{ color: "#676262" }}
                      >
                        {" "}
                        Terms & Conditions{" "}
                      </a>
                    </li>
                  </ul>
                  <hr />
                </div>
              </Col>

              <Col md={10} className="ps-3">
                <Row className="ms-0 w-100" id="companyDetailsSection">
                  <h3
                    className=" mb-4 pt-3"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 300,
                      fontSize: "19px",
                    }}
                  >
                    {" "}
                    Invoice Details
                  </h3>

                  <Row className="ms-0 w-100">
                    <Col md={6} className="ps-0">
                      <Col md={12}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formContact"
                        >
                          <Form.Label style={{ marginBottom: 1 }}>
                            Contact <span className="text-danger">*</span>
                          </Form.Label>

                          <Controller
                            name="contact"
                            control={control}
                            rules={{ required: "Contact is required" }}
                            render={({ field }) => {
                              return (
                                <Select
                                  {...field}
                                  options={contactOptions}
                                  placeholder="Select Contact"
                                  classNamePrefix="react-select"
                                  styles={customStyles}
                                  // Use custom component to show company name below contact name
                                  components={{
                                    Option: CustomOption1,
                                  }}
                                  value={
                                    contactOptions?.find(
                                      (opt) => opt.value === field.value
                                    ) || selectedContact
                                  }
                                  onChange={(selected) =>
                                    handleSelectChange(
                                      "contact",
                                      selected,
                                      field.onChange
                                    )
                                  }
                                />
                              );
                            }}
                          />

                          {errors.contact && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.contact.message}
                            </p>
                          )}
                        </Form.Group>
                      </Col>

                      <Row>
                        <Col md={6}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formQuoteDate"
                          >
                            <Form.Label style={{ marginBottom: 1 }}>
                              Invoice Order Date{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>

                            <Controller
                              name="salesOrderDate"
                              control={control}
                              rules={{
                                required: "Ivoice date  is required",
                                validate: (value) => {
                                  const qDate = new Date(value);
                                  const tDate = new Date(today);

                                  if (qDate < tDate) {
                                    return "Sales order date cannot be in the past";
                                  }
                                  return true;
                                },
                              }}
                              render={({ field }) => (
                                <Form.Control
                                  {...field}
                                  type="date"
                                  placeholder="Select Invoice Date"
                                  min={today}
                                  isInvalid={!!errors.salesOrderDate}
                                />
                              )}
                            />

                            {errors.salesOrderDate && (
                              <p
                                className="text-danger mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                {errors.salesOrderDate.message}
                              </p>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formExpiryDate"
                          >
                            <Form.Label style={{ marginBottom: 1 }}>
                              Invoice Due Date{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>

                            <Controller
                              name="shipmentDate"
                              control={control}
                              rules={{
                                required: "Invoice Due Date is required",
                                validate: (value) => {
                                  const qDate = new Date(salesOrderDate);
                                  const eDate = new Date(value);
                                  if (eDate <= qDate) {
                                    return "Invoice Due date must be after invoce order date";
                                  }
                                  return true;
                                },
                              }}
                              render={({ field }) => (
                                <Form.Control
                                  {...field}
                                  type="date"
                                  placeholder="Select Invoice Due Date"
                                  min={salesOrderDate}
                                />
                              )}
                            />

                            {eDate < qDate && (
                              <p
                                className="text-danger mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                Invoice Due date must be after invoce order date
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={6}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formOwner"
                          >
                            <Form.Label style={{ marginBottom: 1 }}>
                              Company Account Owner{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Controller
                              name="leadOwnerId"
                              control={control}
                              rules={{ required: "Owner is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={leadOwnerOptions}
                                  placeholder="Select Owner"
                                  classNamePrefix="react-select"
                                  styles={customStyles}
                                  value={
                                    leadOwnerOptions.find(
                                      (opt) => opt.value === field.value
                                    ) || selectedLeadOwner
                                  }
                                  onChange={(selected) =>
                                    handleSelectChange(
                                      "leadOwnerId",
                                      selected,
                                      field.onChange
                                    )
                                  }
                                />
                              )}
                            />

                            {errors.leadOwnerId && (
                              <p
                                className="text-danger mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                {errors.leadOwnerId.message}
                              </p>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formDeal"
                          >
                            <Form.Label
                              class="w-auto"
                              style={{ marginBottom: 1 }}
                            >
                              Sales Order
                            </Form.Label>
                            <Controller
                              name="deal"
                              control={control}
                              rules={{ required: "Sales order is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={dealOptions}
                                  placeholder="Select Sales Order"
                                  classNamePrefix="react-select"
                                  styles={customStyles}
                                  value={
                                    dealOptions.find(
                                      (opt) => opt.value === field.value
                                    ) || selectedDeal
                                  }
                                  onChange={(selected) =>
                                    handleSelectChange(
                                      "deal",
                                      selected,
                                      field.onChange
                                    )
                                  }
                                />
                              )}
                            />

                            {errors.deal && (
                              <p
                                className="text-danger mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                {errors.deal.message}
                              </p>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formCompanyName"
                          >
                            <Form.Label
                              class="w-auto"
                              style={{ marginBottom: 1 }}
                            >
                              Accounts Receivables (COA)
                            </Form.Label>
                            <Controller
                              name="accountsReceivables"
                              control={control}
                              rules={{ required: "accountsReceivables required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={quotationOptions}
                                  placeholder="Select quotatio"
                                  classNamePrefix="react-select"
                                  components={{
                                    Option: CustomOption2,
                                  }}
                                  value={
                                    quotationOptions?.find(
                                      (opt) => opt.value === field.value
                                    ) || ""
                                  }
                                  onChange={(selected) =>
                                    handleSelectChange(
                                      "quotation",
                                      selected,
                                      field.onChange
                                    )
                                  }
                                  styles={customStyles}
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formCompanyName"
                          >
                            <Form.Label
                              class="w-auto"
                              style={{ marginBottom: 1 }}
                            >
                              Payment Terms <span className="text-danger">*</span>
                            </Form.Label>
                            <Controller
                              name="paymentTerm"
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={itemOptionsPyments}
                                  placeholder="Select Item"
                                  classNamePrefix="react-select"
                                  styles={customStyles}
                                // value and onChange are already handled by {...field}
                                />
                              )}
                            />
                            {errors.paymentTerm && (
                              <p
                                className="text-danger mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                {errors.paymentTerm.message ||
                                  "please select paymentsssss term"}
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-3 focus-z-index position-relative"
                            controlId="formShortDescription"
                          >
                            <Form.Label style={{ marginBottom: 1 }} className="textareaLables">
                              Short Description (email subject){" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Controller
                              name="shortDescription"
                              control={control}
                              render={({ field }) => (
                                <textarea
                                  {...field}
                                  className="form-control"
                                  placeholder="Enter Short Description"
                                  rows={3}
                                />
                              )}
                            />
                            {errors.shortDescription && (
                              <p
                                className="text-danger mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                Short description is required
                              </p>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      md={5}
                      className="mb-3 ms-3 ps-4"
                      style={{ borderLeft: "1px solid #dae8ed" }}
                    >
                      {selectedContact && (
                        <div className="mt-0 mb-2 col-md-12">
                          {/* Billing Address Section */}
                          <div className="w-100 mb-4">
                            <p
                              className="mb-2 fs-13"
                              style={{
                                color: "#4c526c",
                                textTransform: "uppercase",
                              }}
                            >
                              Billing Address{" "}
                              {/* <FontAwesomeIcon
                              icon={faPen}
                              style={{ color: "#b7a3a3", cursor: "pointer" }}
                              className="ms-1"
                              onClick={() => setShowBillingModal(true)}
                            /> */}
                            </p>

                            {selectedContact.billingAddresses?.filter(
                              (addr) => addr.selected === "selected"
                            ).length > 0 ? (
                              selectedContact.billingAddresses
                                .filter((addr) => addr.selected === "selected")
                                .map((addr, i) => (
                                  <div
                                    key={i}
                                    className="mb-3 p-2 rounded border border-primary"
                                  >
                                    <p
                                      className="mb-0 fs-13 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {addr.address}
                                    </p>
                                    <p
                                      className="mb-0 fs-13 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {addr.city}, {addr.state}, {addr.country} -{" "}
                                      {addr.zipcode}
                                    </p>
                                  </div>
                                ))
                            ) : (
                              <p className="text-muted fs-13">
                                No billing address available
                              </p>
                            )}
                          </div>

                          <div className="w-100">
                            <p
                              className="mb-2 fs-13"
                              style={{
                                color: "#4c526c",
                                textTransform: "uppercase",
                              }}
                            >
                              Shipping Address{" "}
                              {/* <FontAwesomeIcon
                             style={{ color: "#b7a3a3", cursor: "pointer" }}
                              className="ms-1"
                              onClick={() => setShowShippingModal(true)}
                            />  icon={faPen} */}
                            </p>

                            {selectedContact.shippingAddresses?.filter(
                              (addr) => addr.for === "shipping"
                            ).length > 0 ? (
                              selectedContact.shippingAddresses
                                .filter((addr) => addr.for === "shipping")
                                .map((addr, i) => (
                                  <div
                                    key={i}
                                    className="mb-3 p-2 rounded border border-primary"
                                  >
                                    <p
                                      className="mb-0 fs-13 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {addr.address}
                                    </p>
                                    <p
                                      className="mb-0 fs-13 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {addr.city}, {addr.state}, {addr.country} -{" "}
                                      {addr.zipcode}
                                    </p>
                                  </div>
                                ))
                            ) : selectedContact.billingAddresses?.filter(
                              (addr) => addr.selected === "selected"
                            ).length > 0 ? (
                              selectedContact.billingAddresses
                                .filter((addr) => addr.selected === "selected")
                                .map((addr, i) => (
                                  <div
                                    key={i}
                                    className="mb-3 p-2 rounded border border-primary"
                                  >
                                    <p
                                      className="mb-0 fs-13 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {addr.address}
                                    </p>
                                    <p
                                      className="mb-0 fs-13 text-dark"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {addr.city}, {addr.state}, {addr.country} -{" "}
                                      {addr.zipcode}
                                    </p>
                                  </div>
                                ))
                            ) : (
                              <p className="text-muted fs-13">
                                No shipping address available
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                    </Col>
                  </Row>
                  {/* <hr /> */}

                  {/* grouped custom fields */}
                  <div className="mb-3" style={{ marginLeft: "-32px" }}>
                    {grouped &&
                      grouped.length !== 0 &&
                      grouped.map((g) => {
                        const capitalizedName = g.group_name.replace(
                          /\b\w/g,
                          (char) => char.toUpperCase()
                        );
                        return (
                          <div
                            key={g.id}
                            style={{ marginBottom: "100px" }}
                          >
                            {g.groupFields?.length !== 0 && <hr />}
                            <div className="offcanvasSections">
                              <h4
                                id={capitalizedName}
                                className="offcanvasSecHeading"
                              >
                                {g.groupFields?.length !== 0 && capitalizedName}
                              </h4>
                              <Row className="w-100 ms-0 pt-3">
                                {g.groupFields?.length !== 0 &&
                                  g.groupFields?.map((field) => {
                                    return (
                                      <React.Fragment key={field.id}>
                                        {field.label_type === "text" && (
                                          <Col md={6}>
                                            <Text
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "monetary" && (
                                          <Col md={6}>
                                            <Text
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "largeText" && (
                                          <Col md={6}>
                                            <Text
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "numerical" && (
                                          <Col md={6}>
                                            <Text
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "address" && (
                                          <Col md={6}>
                                            <Text
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "single-option" && (
                                          <Col md={6}>
                                            <SelectOpt
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                              options={
                                                field.option !== null &&
                                                field.option
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "user" && (
                                          <Col md={6}>
                                            <SelectOpt
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type="single-option"
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                              options={leadOwner.map((lead) => ({
                                                value: lead.leadId,
                                                label: lead.leadName,
                                              }))}
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "person" && (
                                          <Col md={6}>
                                            <SelectOpt
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type="single-option"
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                              options={
                                                allContacts.length > 0
                                                  ? allContacts
                                                  : []
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "organization" && (
                                          <Col md={6}>
                                            <SelectOpt
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type="single-option"
                                              control={control}
                                              rules={{
                                                required: `${field.label_name} is required`,
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={
                                                field.is_important === "yes"
                                              }
                                            // options={company}
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "time" && (
                                          <Col md={6}>
                                            <Time
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={field.is_important === "yes"}
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "time-range" && (
                                          <Col md={6}>
                                            <Time
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required:
                                                  field.is_required === "yes" &&
                                                  "Working hours are required",
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={field.is_important === "yes"}

                                            />
                                          </Col>
                                        )}

                                        {field.label_type === "phone" && (
                                          <Col md={6}>
                                            <PhoneNumberInput
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required:
                                                  field.is_required === "yes" &&
                                                  "Phone number is required",
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={field.is_important === "yes"}
                                              validatePhoneNumber={
                                                validatePhoneNumber
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "date" && (
                                          <Col md={6}>
                                            <DateField
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              rules={{
                                                required:
                                                  field.is_required === "yes" &&
                                                  "Date is required",
                                              }}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                              isImportant={field.is_important === "yes"}

                                            />
                                          </Col>
                                        )}
                                        {field.label_type === "date range" && (
                                          <Col md={6}>
                                            <DateField
                                              name={field.id}
                                              label_name={field.label_name}
                                              label_type={field.label_type}
                                              control={control}
                                              // rules={{
                                              //   required:
                                              //     field.is_required === "yes" &&
                                              //     "Date Range number is required",
                                              //   validate: {
                                              //     validRange: (value) => {
                                              //       if (
                                              //         !value?.start ||
                                              //         !value?.end
                                              //       )
                                              //         return true; // Let required handle empty values
                                              //       return (
                                              //         value.start <= value.end ||
                                              //         "End date must be after or same as start date"
                                              //       );
                                              //     },
                                              //   },
                                              // }}
                                              isImportant={field.is_important === "yes"}
                                              isRequired={
                                                field.is_required === "yes"
                                              }
                                            />
                                          </Col>
                                        )}
                                        {field.label_type ===
                                          "multiple-option" && (
                                            <Col md={6}>
                                              <MultipleOpt
                                                name={field.id}
                                                label_name={field.label_name}
                                                label_type={field.label_type}
                                                control={control}
                                                isRequired={
                                                  field.is_required === "yes"
                                                    ? true
                                                    : false
                                                }
                                                isImportant={
                                                  field.is_important === "yes"
                                                    ? true
                                                    : false
                                                }
                                                options={
                                                  field.option &&
                                                  JSON.parse(field.option)
                                                }
                                                rules={{
                                                  required:
                                                    field.is_required === "yes" &&
                                                    "Teams is required",
                                                }}
                                              />
                                            </Col>
                                          )}
                                      </React.Fragment>
                                    );
                                  })}
                              </Row>
                            </div>
                          </div>
                        );
                      })}

                    {ungrouped?.length !== 0 && <hr />}
                    <Row
                      className="w-100 ms-0 mt-3"
                      style={{ paddingLeft: "20px" }}
                    >
                      {ungrouped &&
                        ungrouped.length !== 0 &&
                        ungrouped.map((field) => {
                          return (
                            <React.Fragment key={field.id}>
                              {field.label_type === "text" && (
                                <Col md={6}>
                                  <Text
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "monetary" && (
                                <Col md={6}>
                                  <Text
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "largeText" && (
                                <Col md={6}>
                                  <Text
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "numerical" && (
                                <Col md={6}>
                                  <Text
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "address" && (
                                <Col md={6}>
                                  <Text
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "single-option" && (
                                <Col md={6}>
                                  <SelectOpt
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                    options={
                                      field.option !== null && field.option
                                    }
                                  />
                                </Col>
                              )}
                              {field.label_type === "user" && (
                                <Col md={6}>
                                  <SelectOpt
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    control={control}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                    options={leadOwner}
                                  />
                                </Col>
                              )}
                              {field.label_type === "person" && (
                                <Col md={6}>
                                  <SelectOpt
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    control={control}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                    options={
                                      allContacts.length > 0 ? allContacts : []
                                    }
                                  />
                                </Col>
                              )}
                              {field.label_type === "organization" && (
                                <Col md={6}>
                                  <SelectOpt
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required: `${field.label_name} is required`,
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    isImportant={field.is_important === "yes"}
                                  //  options={company}
                                  />
                                </Col>
                              )}
                              {field.label_type === "time" && (
                                <Col md={6}>
                                  <Time
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    isRequired={field.is_required === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "time-range" && (
                                <Col md={6}>
                                  <Time
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required:
                                        field.is_required === "yes" &&
                                        "Working hours are required",
                                      validate: {
                                        validRange: (value) => {
                                          if (!value?.start || !value?.end)
                                            return true; // Let required handle empty values
                                          return (
                                            value.start < value.end ||
                                            "End time must be after start time"
                                          );
                                        },
                                      },
                                    }}
                                    isRequired={field.is_required === "yes"}
                                  />
                                </Col>
                              )}

                              {field.label_type === "phone" && (
                                <Col md={6}>
                                  <PhoneNumberInput
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required:
                                        field.is_required === "yes" &&
                                        "Phone number is required",
                                    }}
                                    isRequired={field.is_required === "yes"}
                                    validatePhoneNumber={validatePhoneNumber}
                                  />
                                </Col>
                              )}
                              {field.label_type === "date" && (
                                <Col md={6}>
                                  <DateField
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required:
                                        field.is_required === "yes" &&
                                        "Date is required",
                                    }}
                                    isRequired={field.is_required === "yes"}
                                  />
                                </Col>
                              )}
                              {field.label_type === "date range" && (
                                <Col md={6}>
                                  <DateField
                                    name={field.id}
                                    label_name={field.label_name}
                                    label_type={field.label_type}
                                    labelClass="mb-3 focus-z-index position-relative"
                                    control={control}
                                    rules={{
                                      required:
                                        field.is_required === "yes" &&
                                        "Date Range number is required",
                                      validate: {
                                        validRange: (value) => {
                                          if (!value?.start || !value?.end)
                                            return true; // Let required handle empty values
                                          return (
                                            value.start <= value.end ||
                                            "End date must be after or same as start date"
                                          );
                                        },
                                      },
                                    }}
                                    isRequired={field.is_required === "yes"}
                                  />
                                </Col>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </Row>
                    {ungrouped?.length !== 0 && <hr />}
                  </div>

                  <Row id="itemsDetailsSection">
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                      }}
                    >
                      {" "}
                      Items Details
                    </h3>

                    <Col md={12} className="pe-0">
                      <div className="table-responsive quatationsTables mb-3 ">
                        <table className="table mb-0">
                          <thead>
                            <tr>
                              <th className="text-start" style={{ width: "15%" }}>
                                Items Name
                              </th>
                              <th style={{ width: "10%" }} className="text-end">
                                Quantity
                              </th>
                              <th style={{ width: "11%" }} className="text-end">
                                Rate{" "}
                              </th>
                              <th style={{ width: "11%" }} className="text-end">
                                {" "}
                                GST(<i className="bi bi-percent"></i>)
                              </th>
                              <th style={{ width: "16%" }} className="text-end">
                                Discount(<i className="bi bi-percent"></i>/
                                <i className="ti ti-currency-rupee"></i>)
                              </th>
                              <th
                                style={{ width: "11%" }}
                                className="text-center"
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {fields.map((field, index) => (
                              <tr key={field.id}>
                                <td className="text-start">
                                  <div>
                                    <Controller
                                      name={`items.${index}.item`}
                                      control={control}
                                      render={({ field: formField }) => (
                                        <div className="mt-0 focus-z-index">
                                          <Select
                                            {...formField}
                                            options={productOptions}
                                            placeholder="Select Item"
                                            styles={customStyle}
                                            value={formField.value}
                                            onChange={(selected) =>
                                              handleProductSelect(
                                                selected,
                                                index,
                                                formField.onChange
                                              )
                                            }
                                            isDisabled
                                          />
                                        </div>
                                      )}
                                    />

                                    {items
                                      ? ""
                                      : errors.items?.[index]?.item && (
                                        <p
                                          className="text-danger mt-1"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {errors.items[index].item.message}
                                        </p>
                                      )}
                                  </div>
                                </td>

                                <td>
                                  <Controller
                                    name={`items.${index}.quantity`}
                                    control={control}
                                    render={({ field }) => (
                                      <input
                                        type="number"
                                        className="normalInput text-end"
                                        placeholder="00"
                                        value={field.value ?? 0}
                                        onChange={(e) => {
                                          let num = e.target.valueAsNumber;

                                          if (Number.isNaN(num)) num = 0;

                                          field.onChange(num); //
                                        }}
                                      />
                                    )}
                                  />

                                  {errors.items?.[index]?.quantity && (
                                    <p
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors.items[index].quantity.message}
                                    </p>
                                  )}
                                </td>

                                <td>
                                  <Controller
                                    name={`items.${index}.rate`}
                                    control={control}
                                    render={({ field: rateField }) => (
                                      <input
                                        {...rateField}
                                        type="number"
                                        className="normalInput text-end"
                                        placeholder="00.00"
                                        readOnly={true}
                                        onChange={(e) =>
                                          rateField.onChange(
                                            Number.parseFloat(e.target.value) || 0
                                          )
                                        }
                                      />
                                    )}
                                  />  <i
                                    className="ti ti-currency-rupee"
                                    style={{
                                      position: "absolute",
                                      marginLeft: "-20px",
                                      marginTop: "10px",
                                    }}
                                  ></i>
                                  {errors.items?.[index]?.rate && (
                                    <p
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors.items[index].rate.message}
                                    </p>
                                  )}
                                </td>
                                <td>
                                  <Controller
                                    name={`items.${index}.gst`}
                                    control={control}
                                    render={({ field: gstField }) => (
                                      <input
                                        {...gstField}
                                        readOnly={true}
                                        type="number"
                                        className="normalInput text-end"
                                        placeholder="0.00"
                                        style={{ paddingRight: 23 }}
                                      />
                                    )}
                                  />
                                  <i
                                    className="bi bi-percent"
                                    style={{
                                      position: "absolute",
                                      marginLeft: "-20px",
                                      marginTop: "8px",
                                    }}
                                  ></i>
                                  {errors.items?.[index]?.gst && (
                                    <p
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors.items[index].gst.message}
                                    </p>
                                  )}
                                </td>

                                <td>
                                  <div className="d-flex gap-1">
                                    <Controller
                                      name={`items.${index}.discount`}
                                      control={control}
                                      render={({ field: discountField }) => (
                                        <input
                                          {...discountField}
                                          readOnly={true}
                                          type="number"
                                          className="normalInput text-end"
                                          placeholder="0.00"
                                          onChange={(e) =>
                                            discountField.onChange(
                                              Number.parseFloat(e.target.value) ||
                                              0
                                            )
                                          }
                                        />
                                      )}
                                    />
                                    {/* <Controller
                                    name={`items.${index}.discountType`}
                                    control={control}
                                    render={({ field: typeField }) => (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "50px",
                                        }}
                                      >
                                        <div
                                          onClick={() =>
                                            handleSelect(
                                              index,
                                              typeField.value === "Percentage"
                                                ? "INR"
                                                : "Percentage"
                                            )
                                          }
                                          style={{
                                            padding: "6px 5px 6px 10px",
                                            border: "1px solid lightblue",
                                            cursor: "pointer",
                                            minHeight: 35,
                                            borderRadius: 4,
                                            backgroundColor: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <span>
                                            <i
                                              className={
                                                options.find(
                                                  (opt) =>
                                                    opt.value ===
                                                    typeField.value
                                                )?.icon
                                              }
                                              style={{ marginRight: "8px" }}
                                            ></i>
                                          </span>
                                          <span
                                            style={{
                                              marginLeft: "auto",
                                              color: "#ccc",
                                            }}
                                          >
                                            <FontAwesomeIcon
                                              icon={faChevronDown}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                  /> */}
                                    <Controller
                                      name={`items.${index}.discountType`}
                                      control={control}
                                      render={({ field: typeField }) => (
                                        <div style={{ width: "100px" }}>
                                          <Select
                                            {...typeField}
                                            options={options}
                                            classNamePrefix=""
                                            isSearchable={false}
                                            isDisabled
                                            onChange={(selectedOption) => {
                                              typeField.onChange(
                                                selectedOption.value
                                              );
                                            }}
                                            value={options.find(
                                              (opt) =>
                                                opt.value === typeField.value
                                            )}
                                            styles={{
                                              control: (base) => ({
                                                ...base,
                                                minHeight: 35,
                                                paddingLeft: 4,
                                              }),
                                              indicatorsContainer: (base) => ({
                                                ...base,
                                                paddingRight: 4,
                                              }),
                                              dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: 2,
                                              }),
                                            }}
                                          />
                                        </div>
                                      )}
                                    />
                                  </div>
                                  {errors.items?.[index]?.discount && (
                                    <p
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors.items[index].discount.message}
                                    </p>
                                  )}
                                </td>
                                <td className="text-end">
                                  <div className="d-flex gap-2 align-items-center justify-content-center">
                                    <div
                                      className="fs-14 text-end"
                                      style={{ fontWeight: 500, fontSize: 14 }}
                                    >
                                      {/* <FontAwesomeIcon icon={faIndianRupeeSign} />{" "} */}
                                      {formatToINR(calculateItemAmount(index))}
                                    </div>

                                    {fields.length > 1 && (
                                      <>
                                        <p
                                          className="mb-0"
                                          style={{
                                            width: 1,
                                            background: "lightblue",
                                            height: 22,
                                          }}
                                        ></p>
                                        <Button
                                          variant="link"
                                          className="text-danger ms-0 p-0"
                                          onClick={() => handleDeleteRow(index)}
                                          title="Delete Row"
                                        >
                                          <FontAwesomeIcon icon={faXmark} />
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}

                            <tr>
                              <th
                                colSpan={2}
                                className="text-start bg-transparent border-0 vertical-top"
                                style={{ verticalAlign: "bottom" }}
                              >
                                <div className="mt-0">
                                  <p
                                    className="ps-1 mb-2 fs-13"
                                    style={{ fontWeight: 400 }}
                                  >
                                    Customer Note
                                  </p>
                                  <Controller
                                    name="customerNote"
                                    control={control}
                                    render={({ field }) => (
                                      <textarea
                                        {...field}
                                        placeholder="Looking forward for your business."
                                        className="normalTextareaQuotation"
                                      />
                                    )}
                                  />
                                </div>
                              </th>
                              <th
                                colSpan={5}
                                className="text-start bg-transparent border-0 "
                              >
                                <div
                                  className=" w-100 h-100 p-3"
                                  style={{
                                    borderRadius: 5,
                                    background: "#f9f9fb",
                                  }}
                                >
                                  <div className="row sub-total mb-2 ">
                                    <div className="total-label fs-14 fw-15 col-md-6 d-flex align-items-center">
                                      Sub Total
                                    </div>
                                    <div className="total-amount text-end fs-14 fw-15 col-md-6 d-flex gap-1 align-items-center justify-content-end">
                                      {/* <FontAwesomeIcon icon={faIndianRupeeSign} />{" "} */}
                                      {formatToINR(calculateSubTotal())}
                                    </div>
                                  </div>

                                  <div className="row sub-total mb-2">
                                    <div className="total-label col-md-4 d-flex align-items-center fs-13 fw-400 text-secondary">
                                      Special Discount
                                    </div>
                                    <div className="total-amount text-center fs-13 fw-400 text-secondary col-md-5 d-flex gap-1">
                                      <Controller
                                        name="specialDiscount"
                                        control={control}
                                        render={({ field: discountField }) => (
                                          <input
                                            {...discountField}
                                            type="number"
                                            className="normalInput text-end "
                                            placeholder="00"
                                            readOnly
                                            onChange={(e) =>
                                              discountField.onChange(
                                                Number.parseFloat(
                                                  e.target.value
                                                ) || 0
                                              )
                                            }
                                          />
                                        )}
                                      />

                                      <Controller
                                        name="specialDiscountType"
                                        control={control}
                                        render={({ field: typeField }) => (
                                          <div style={{ width: "90px" }}>
                                            <Select
                                              {...typeField}
                                              options={discountTypeOptions}
                                              classNamePrefix=""
                                              isSearchable={false}
                                              isDisabled
                                              onChange={(selectedOption) => {
                                                typeField.onChange(
                                                  selectedOption.value
                                                );
                                              }}
                                              value={discountTypeOptions.find(
                                                (opt) =>
                                                  opt.value === typeField.value
                                              )}
                                              styles={{
                                                control: (base) => ({
                                                  ...base,
                                                  minHeight: 35,
                                                  paddingLeft: 4,
                                                  borderColor: "lightblue",
                                                  borderRadius: 4,
                                                  cursor: "pointer",
                                                }),
                                                dropdownIndicator: (base) => ({
                                                  ...base,
                                                  padding: 2,
                                                }),
                                                indicatorsContainer: (base) => ({
                                                  ...base,
                                                  paddingRight: 4,
                                                }),
                                              }}
                                            />
                                          </div>
                                        )}
                                      />
                                    </div>

                                    <div className="total-amount text-end fs-13 fw-400 text-secondary col-md-3 d-flex align-items-center justify-content-end">
                                      -{" "}
                                      {/* <FontAwesomeIcon
                                      icon={faIndianRupeeSign}
                                      style={{ marginRight: "3px" }}
                                    />{" "} */}
                                      {formatToINR(calculateDiscountAmount())}
                                    </div>
                                  </div>

                                  <div className="row sub-total mb-2">
                                    <div className="total-label col-md-4 d-flex align-items-center fs-13 fw-400 text-secondary">
                                      Shipping Charge
                                    </div>
                                    <div className="total-amount text-center col-md-5">
                                      <Controller
                                        name="shippingCharge"
                                        control={control}
                                        render={({ field }) => (
                                          <input
                                            {...field}
                                            type="number"
                                            // style={{
                                            //   width : '11.1rem',
                                            //   marginRight :'6.5rem'
                                            // }}
                                            readOnly
                                            className="normalInput text-end "
                                            placeholder="00"
                                            onChange={(e) =>
                                              field.onChange(
                                                Number.parseFloat(
                                                  e.target.value
                                                ) || 0
                                              )
                                            }
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="total-amount text-end fs-13 fw-400 text-secondary col-md-3 d-flex align-items-center justify-content-end">
                                      {/* <FontAwesomeIcon
                                      icon={faIndianRupeeSign}
                                      style={{ marginRight: "3px" }}
                                    />{" "} */}
                                      {formatToINR(watch("shippingCharge") || 0)}
                                    </div>
                                  </div>

                                  {Object.entries(calculateGroupedGST())
                                    .filter(([gstRate]) => Number(gstRate) > 0)
                                    .sort(([a], [b]) => Number(a) - Number(b)) // GST percentage ascending
                                    .map(([gstRate, gstAmount]) => (
                                      <div
                                        className="row sub-total mb-2"
                                        key={gstRate}
                                      >
                                        <div className="total-label col-md-4 d-flex align-items-center fs-13 fw-400 text-secondary">
                                          GST ({gstRate}%)
                                        </div>
                                        <div className="total-amount text-center col-md-5"></div>
                                        <div className="total-amount text-end fs-13 fw-400 text-secondary col-md-3  d-flex align-items-center justify-content-end">
                                          {/* <FontAwesomeIcon
                                          icon={faIndianRupeeSign}
                                        />{" "} */}
                                          {formatToINR(gstAmount.toFixed(2))}
                                        </div>
                                      </div>
                                    ))}

                                  <div className="row sub-total ">
                                    <div className="total-label fs-13 fw-400 text-secondary col-md-6">
                                      Round Off (
                                      <i className="ti ti-currency-rupee"></i>)
                                    </div>
                                    <div className="total-amount text-end fs-13 fw-400 text-secondary col-md-6">
                                      {/* <FontAwesomeIcon icon={faIndianRupeeSign} />{" "} */}
                                      {formatToINR(roundOff.toFixed(2))}
                                    </div>
                                  </div>

                                  <hr />

                                  <div className="row sub-total">
                                    <div className="total-label fs-14 fw-500  col-md-6">
                                      Grand Total (
                                      <i className="ti ti-currency-rupee"></i>)
                                    </div>
                                    <div className="total-amount text-end fs-14 fw-500 text-semibold col-md-6">
                                      {/* <FontAwesomeIcon icon={faIndianRupeeSign} />{" "} */}
                                      {formatToINR(grandTotal)}
                                    </div>
                                  </div>
                                </div>
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>

                  <hr />

                  <Row id="termsAndConditionsSec">
                    <Col md={8}>
                      <h3
                        className=" mb-3"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                        }}
                      >
                        {" "}
                        Terms & Conditions{" "}
                      </h3>

                      <Form.Group
                        className="mb-3"
                        controlId="formTermsConditions"
                      >
                        <Controller
                          name="termsConditions"
                          control={control}
                          render={({ field }) => (
                            <textarea
                              {...field}
                              className="normalTextarea"
                              placeholder="Enter the terms and conditions of your business to be displayed in your transaction"
                              style={{ minHeight: 81 }}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4} className="mb-3">
                      <h3
                        className=" mb-3"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                        }}
                      >
                        {" "}
                        Add Attachment{" "}
                      </h3>
                      <div
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        style={{
                          border: "2px dashed #ccc",
                          borderRadius: "10px",
                          padding: "10px 20px",
                          textAlign: "center",
                          background: isDragging ? "#e0f3ff" : "#f9f9f9",
                          width: "100%",
                          maxWidth: "400px",
                          cursor: "pointer",
                        }}
                      >
                        <p style={{ marginBottom: "5px", color: "#666" }}>
                          {file
                            ?
                            <>
                              {`Selected: ${file.name}`}   <IconXboxX
                                stroke={2}
                                size={18}
                                style={{ stroke: "red", cursor: "pointer" }}
                                onClick={() => setFile(null)}
                              />
                            </>
                            : "Drag & drop or click to upload a file"}
                        </p>
                        <button
                          type="button"
                          onClick={handleClickButton}
                          style={{
                            padding: "5px 20px",
                            backgroundColor: "#0099ff",
                            color: "#fff",
                            borderRadius: "5px",
                            cursor: "pointer",
                            border: "none",
                            fontSize: "16px",
                          }}
                        >
                          <FontAwesomeIcon icon={faCloudUpload} /> Browse File
                        </button>

                        <input
                          type="file"
                          ref={fileInputRef}
                          onChange={handleChange}
                          style={{ display: "none" }}
                        />
                      </div>
                      <div
                        style={{
                          // marginTop: "10px",
                          width: "100%",
                          maxWidth: "400px",
                          textAlign: "center",
                        }}
                      >
                        <p
                          style={{
                            color: "#a5a5a5",
                            fontSize: "11px",
                            fontWeight: "400",
                            margin: 0,
                          }}
                        >
                          Accepted file types are .jpg, .png, .pdf and .jpeg max file
                          size 5MB
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Row>
                <div className="zb-txn-form mb-4 text-center">
                </div>

                <p style={{ height: "8rem" }}></p>

                <div
                  className="bg-white position-sticky"
                  style={{
                    paddingTop: "13px",
                    paddingBottom: "15px",
                    paddingRight: "17px",
                    bottom: "67.5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    zIndex: 11,
                    borderTop: "1px solid lightblue",
                  }}
                >
                  <Button
                    className="btn btn-default-outline me-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-default "
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Submitting...." : " Submit"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>

          <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: 18, fontWeight: 400 }}>
                Create Quotation Series
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form action="" method="post" className="form-container">
                <div className="form-check ps-1 mb-1 d-flex align-items-center ">
                  <input
                    type="text"
                    value=""
                    id="feeReceiptId"
                    name="feeReceiptId"
                    hidden
                  />
                  <input
                    type="radio"
                    name=""
                    id=""
                    className="me-2"
                    style={{ width: 17, height: 17 }}
                  />

                  <p className="form-label mt-1">NG-2025-08-100</p>
                </div>
                <div className="form-check mb-1 ps-1 d-flex align-items-center">
                  <input
                    type="radio"
                    name=""
                    id=""
                    className="me-2"
                    style={{ width: 17, height: 17 }}
                  />
                  <p className="form-label mt-1">NG-08-2025-100</p>
                </div>
                <div className="form-check ps-1 mb-1 d-flex align-items-center">
                  <input
                    type="radio"
                    name=""
                    id=""
                    className="me-2"
                    style={{ width: 17, height: 17 }}
                  />
                  <p className="form-label mt-1">NG-2025-100</p>
                </div>
                <div className="form-check ps-1 mb-1 d-flex align-items-center">
                  <input
                    type="radio"
                    name=""
                    id=""
                    className="me-2"
                    style={{ width: 17, height: 17 }}
                  />
                  <p className="form-label mt-1">NG-100</p>
                </div>
                <div className="input-div position-relative focus-z-index mt-3 mb-2">
                  <label htmlFor="incrementalNo" className="form-label">
                    Enter Incremental Number Here: <span>*</span>
                  </label>
                  <input
                    type="number"
                    name="incrementalNumber"
                    className="form-control prefix-element "
                    id="incrementalNumber"
                    placeholder="Enter Any 4 Digits"
                    required=""
                  />
                </div>
                <div className="input-div position-relative focus-z-index mt-3 mb-4">
                  <label htmlFor="summaryPermission" className="form-label">
                    Want Course Fee Summary? <span>*</span>
                  </label>
                  <select
                    name="summaryPermission"
                    id="summaryPermission"
                    className="form-select"
                    onChange={() => { }}
                    required=""
                  >
                    <option value="1" selected={true}>
                      Yes
                    </option>
                    <option value="0">No</option>
                  </select>
                </div>
                <Modal.Footer>
                  <Button variant="default-outline" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="default" onClick={() => alert("Saved!")}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </form>
            </Modal.Body>
          </Modal>
          <AddressModal
            show={showBillingModal}
            handleClose={() => setShowBillingModal(false)}
            onSubmit={handleBillingSubmit}
            contactOption={selectedContact}
            // pass current contact object
            setSelectedContact={setSelectedContact}
            title="Create New Billing Address"
            defaultFor="billing"
          />

          <AddressModal
            show={showShippingModal}
            handleClose={() => setShowShippingModal(false)}
            onSubmit={handleShippingSubmit}
            contactOption={selectedContact}
            title="Create New Shipping Address"
            defaultFor="shipping"
            setSelectedContact={setSelectedContact}
          />
        </div>
      </>
      }
    </>
  );
};
